import ps from '@/payment-service'

export const getBasketData = async id => {
  return await ps.getCart(id)
}
export const addProductsToBasket = async (basketId, nomenklatures) => {
  return ps.addProductsToCart(basketId, nomenklatures)
}
export const removeProductFromBasket = async (basketId, nomenklatura) => {
  return await ps.removeProductFromCart(basketId, nomenklatura)
}
export const emptyBasket = async id => {
  return ps.emptyCart(id)
}
export const applyPromocodeToBasket = async (basketId, promocode) => {
  return ps.applyPromocodeToCart(basketId, promocode)
}
export const getBasketPaymentLink = id => {
  return ps.getCartPaymentLink(id)
}
